// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css';
// import iviewArea from 'iview-area'
import App from './App'
import {router} from './router/index'
import store from './store'
import i18n from '@/locale'
import Icon from 'vue-awesome/components/Icon'
// 按需引入awesome图标
import 'vue-awesome/icons/brands/qq'
import 'vue-awesome/icons/brands/weixin'
import 'vue-awesome/icons/brands/weibo'
import 'vue-awesome/icons/brands/github'
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest,getRequestWithNoToken} from '@/libs/axios'
import {setStore, getStore, removeStore} from '@/libs/storage'
import Cookies from "js-cookie"
import util from '@/libs/util'
import dictUtil from '@/libs/dictUtil'
import hasPermission from '@/libs/hasPermission'
import hasRole from '@/libs/hasRole'
import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'
import VueApexCharts from 'vue-apexcharts'
import MetaInfo from 'vue-meta-info'
import '@babel/polyfill'
import {userInfo} from "@/api/index";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import {bqjUrl,svipUrl} from "@/config/config"

import {getStsA} from "@/api/ipAuth"

// import { requestData, request_api, queryData } from "@/libs/request.js";
// Vue.prototype.request = requestData;

var totalUserImg = '';


Vue.config.devtools = true;
Vue.config.productionTip = false
Vue.use(VueLazyload, {
    error: require('./assets/img-error.png'),
    loading: require('./assets/loading2.gif')
})
Vue.use(ViewUI, {
    i18n: (key, value) => i18n.t(key, value)
});
// Vue.use(iviewArea);
Vue.use(VueClipboard);
Vue.component('icon', Icon);
Vue.use(hasPermission);
Vue.use(hasRole);
Vue.use(MetaInfo)
Vue.use(VueApexCharts)
Vue.use(ElementUI)
Vue.component('apexchart', VueApexCharts)
// 挂载全局使用的方法
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.getRequestWithNoToken = getRequestWithNoToken;
Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;
// Vue.prototype.API_ROOT_UPLOAD = 'https://vipback.bqj.cn/'; //正式环境
// Vue.prototype.API_ROOT_UPLOAD  = 'https://previpback.bqj.cn/'; //预发布环境
 Vue.prototype.API_ROOT_UPLOAD = bqjUrl+"/"; //测试环境

// Vue.prototype.API_ROOT_MARS = 'https://tsmars.bqj.cn/'; //取证平台测试环境
Vue.prototype.API_ROOT_MARS = svipUrl; //取证平台生产环境

//吐司
window.toast = function (str, callbacks) {
//  console.log('获取的回调函数的上下文', callbacks)
    var m = document.createElement('div');
    m.innerHTML = str;
    m.style.cssText = "padding:0 28px;font-size:16px; min-width:150px; background:#000; opacity:0.77; height:90px; color:#fff; line-height:90px; text-align:center; border-radius:10px; position:fixed; left:50%; top:50%; transform:translate(-50%,-50%); z-index:99999999;";
    document.body.appendChild(m);
    setTimeout(function () {
        var d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m);
            if (callbacks) {
                callbacks()
            }
        }, d * 1000);
    }, 2000);
}
/* eslint-disable no-new */

 //百度埋点
 window.burialPoint = function burialPoint(type,op,value){
    try{
        _hmt.push(['_trackEvent', type, op, value, new Date().getTime()]);
    }catch(e){
        console.log(e)
    }
}

router.beforeEach((to, from, next) => {
	
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', to.fullPath])
        }
    }


    let accessToken = getStore('accessToken');
    //如果没有Store的token
    if (!accessToken || accessToken == '') {

        //有全域token
        if (Cookies.get('accessToken') && Cookies.get('accessToken') != '') {
            accessToken = Cookies.get('accessToken');
            setStore("accessToken", accessToken);

            // 获取用户信息
            userInfo().then(res => {

                if (res.code == 200) {
                    Cookies.set("userInfo", JSON.stringify(res.result));
                    setStore("userInfo", res.result);
                    let photo = res.result.photo ? res.result.photo : '';
                    store.commit("setAvatarPath", photo);

                    // 加载菜单
                    util.initRouter(this);
                    next()
                } else {
                    next()
                }
            },err=>{
                next()
            });
        } else {
            next()
        }
    }
    //如果有token
    else {

        if(!Cookies.get('userInfo') || Cookies.get('userInfo') == ''){
            // 获取用户信息
            userInfo().then(res => {

                if (res.code == 200) {
                    Cookies.set("userInfo", JSON.stringify(res.result));
                    setStore("userInfo", res.result);
                    totalUserImg = res.result.photo ? res.result.photo : '';
                    store.commit("setAvatarPath", totalUserImg);
                    // 加载菜单
                    util.initRouter(this);
                    next()
                } else {
                    next()
                }
            },err=>{
                next()
            });
        }
        else{
            next()

        }
    }




})

// ip授权获取图片的一些数据，别问，问就是ctrl + c + v
let OSS = require("ali-oss");
// refer to:  https://github.com/ali-sdk/ali-oss?spm=a2c4g.11186623.2.16.44342bd0VNYZCq#user-content-signatureurlname-options
// 注意，代码中的Secret信息是STS的，可能已经过期。所以先用 getsts 得到一组临时的然后复制过来访问。

let client = "";

if (Cookies.get("ossObj")) {
  let ossObj = JSON.parse(Cookies.get("ossObj"));
  client = new OSS({
    region: ossObj.Region,
    accessKeyId: ossObj.AccessKeyId,
    accessKeySecret: ossObj.AccessKeySecret,
    stsToken: ossObj.SecurityToken,
    expiration: ossObj.Expiration,
    bucket: ossObj.Bucket,
    endpoint: ossObj.Endpoint,
    secure: ossObj.Secure,
    cname: ossObj.Cname
  });
} else {
  getSts();
}

function getSts() {
    // 需修改 Region Bucket Endpoint
    let ossObj = {
        Region: "oss-cn-chengdu",
        AccessKeyId: "",
        AccessKeySecret: "",
        Expiration: "",
        SecurityToken: "",
        Bucket: "gangan-ipprivate",
        Endpoint: "ipprivate.gsbqfw.com",
        Secure: true,
        Cname: true
    };
    getStsA().then(res => {
        
        ossObj.AccessKeyId = res.data.AccessKeyId;
        ossObj.AccessKeySecret = res.data.AccessKeySecret;
        ossObj.Expiration = res.data.Expiration;
        ossObj.SecurityToken = res.data.SecurityToken;
        Cookies.set("ossObj", JSON.stringify(ossObj), {
            expires: new Date(
            new Date(ossObj.Expiration).getTime() - 1000 * 60 * 10
            )
        });
        return new Promise(function(resolve, reject) {
            client = new OSS({
            region: ossObj.Region,
            accessKeyId: ossObj.AccessKeyId,
            accessKeySecret: ossObj.AccessKeySecret,
            stsToken: ossObj.SecurityToken,
            bucket: ossObj.Bucket,
            endpoint: ossObj.Endpoint,
            secure: ossObj.Secure,
            cname: ossObj.Cname
            });
            resolve(); // 数据处理完成
            // reject('失败') // 数据处理出错
        });
    })
    .then(res => {})
    .catch(err => {
    // console.log("失败：", err);
    });
}
// 构造签名参数
// expTime: 失效时间,秒
// imageProcess: 图片处理参数
// filename: 如果设置一个文件名，则浏览器以请求的文件名来下载附件，而不是内联浏览

var setSignatureOptions = function(expTime, imageProcess, fileName) {
    var opt = {
      expires: expTime
    };
  
    if (imageProcess) {
      opt.process = imageProcess;
    }
  
    if (fileName) {
      opt.response = {
        "content-disposition": "attachment; filename=" + fileName // 图片附件下载
      };
    }
  
    return opt;
};
// var url = client.signatureUrl('kztest/杯子-small.png', setSignatureOptions(3600, 'image/resize,w_100', 'bezi.png'));
// console.log(url);

// var url = client.signatureUrl('kztest/杯子-small.png', setSignatureOptions(3600, 'image/resize,w_100'));
// console.log(url);

Vue.directive("imgToken", {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el, binding) {
      if (!Cookies.get("ossObj")) {
        new Promise(function(resolve, reject) {
          getSts();
          resolve();
        }).then(function(res) {
          if (!binding.value) {
            el.src = "";
            // console.log('无图片');
            return;
          }
          if (binding.value === binding.oldValue) {
            // console.log('本地图片');
            return;
          }
  
          if (binding.value && binding.value.includes("http")) {
            if (binding.value.lastIndexOf("ip") == 39) {
              let src = client.signatureUrl(
                binding.value.slice(42),
                setSignatureOptions(
                  (new Date(Cookies.get("ossObj").Expiration).getTime() -
                    new Date().getTime()) /
                    1000
                )
              );
              el.src = src;
            }
          } else {
            // console.log('其他')
          }
        });
      } else {
        if (!binding.value) {
          el.src = "";
          // console.log('无图片');
          return;
        }
        if (binding.value === binding.oldValue) {
          // console.log('本地图片');
          return;
        }
  
        if (binding.value && binding.value.includes("http")) {
          if (binding.value.lastIndexOf("ip") == 39) {
            let src = client.signatureUrl(
              binding.value.slice(42),
              setSignatureOptions(3600)
            );
            el.src = src;
          }
        } else {
          // console.log('其他')
        }
      }
    },
    update: function(el, binding) {
      // console.log(binding)
      if (!binding.value) {
        el.src = "";
        // console.log('更新-无图片');
        return;
      }
      if (binding.value && binding.value === binding.oldValue) {
        // console.log('新图',binding.value);
        // console.log('老图',binding.oldValue);
        return;
      }
      if (binding.value && binding.value.includes("http")) {
        el.src = binding.value + "!thumbnail";
        // console.log('新图',binding.value);
      } else {
        // console.log('更新-其他')
      }
    }
});

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    data: {
        currentPageName: ''
    },
    mounted() {
        // 初始化菜单
        util.initRouter(this);
        // 初始化全局数据字典
        dictUtil.initDictData(this);
        this.currentPageName = this.$route.name;
        // 显示打开的页面的列表
        this.$store.commit('setOpenedList');
        this.$store.commit('initCachepage');
         document.dispatchEvent(new Event('render-event'))
    }
})//.$mount('#app')


// 注入
let mixin = {
    methods: {
      sts: function(src, uid,label) {
        const index_ = 39; // 截取图片url位置，只需要图片url的id
        if (!Cookies.get("ossObj")) {
          new Promise(function(resolve, reject) {
            getSts();
            resolve();
          }).then(function(res) {
            console.log(res);
            if (src && src.includes("http")) {
              if (src.lastIndexOf("ip") == index_) {
                let src_;
                if (label) {
                  src_ = client.signatureUrl(
                    src.slice(index_ + 3),
                    setSignatureOptions(
                      new Date(
                        JSON.parse(Cookies.get("ossObj")).Expiration
                      ).getTime() / 1000,
                      label
                    )
                  );
                } else {
                  src_ = client.signatureUrl(
                    src.slice(index_ + 3),
                    setSignatureOptions(
                      new Date(
                        JSON.parse(Cookies.get("ossObj")).Expiration
                      ).getTime() / 1000
                    )
                  );
                }
                return src_;
              }
              if (src.lastIndexOf("specials") == index_) {
                let src_;
                if (label) {
                  src_ = client.signatureUrl(
                    src.slice(index_ + 9),
                    setSignatureOptions(
                      new Date(
                        JSON.parse(Cookies.get("ossObj")).Expiration
                      ).getTime() / 1000,
                      label
                    )
                  );
                } else {
                  src_ = client.signatureUrl(
                    src.slice(index_ + 9),
                    setSignatureOptions(
                      new Date(
                        JSON.parse(Cookies.get("ossObj")).Expiration
                      ).getTime() / 1000
                    )
                  );
                }
                return src_;
              }
              if (src.lastIndexOf("chances") == index_) {
                return src;
              }
              if (src.lastIndexOf("order") == index_) {
                let src_;
                if (label) {
                  src_ = client.signatureUrl(
                    src.slice(index_),
                    setSignatureOptions(
                      new Date(
                        JSON.parse(Cookies.get("ossObj")).Expiration
                      ).getTime() / 1000,
                      label
                    )
                  );
                } else {
                  src_ = client.signatureUrl(
                    src.slice(index_),
                    setSignatureOptions(
                      new Date(
                        JSON.parse(Cookies.get("ossObj")).Expiration
                      ).getTime() / 1000
                    )
                  );
                }
                return src_;
              }
            } else {
              // console.log('其他')
            }
          });
        } else {
          if (src && src.includes("http")) {
    
            if (src.lastIndexOf("ip") == index_) {
              let src_;
              if (label) {
                src_ = client.signatureUrl(
                  src.slice(index_ + 3),
                  setSignatureOptions(
                    new Date(
                      JSON.parse(Cookies.get("ossObj")).Expiration
                    ).getTime() / 1000,
                    label
                  )
                );
              } else {
                src_ = client.signatureUrl(
                  src.slice(index_ + 3),
                  setSignatureOptions(
                    new Date(
                      JSON.parse(Cookies.get("ossObj")).Expiration
                    ).getTime() / 1000
                  )
                );
              }
              return src_;
            }
            if (src.lastIndexOf("specials") == index_) {
              let src_;
              if (label) {
                src_ = client.signatureUrl(
                  src.slice(index_ + 9),
                  setSignatureOptions(
                    new Date(
                      JSON.parse(Cookies.get("ossObj")).Expiration
                    ).getTime() / 1000,
                    label
                  )
                );
              } else {
                src_ = client.signatureUrl(
                  src.slice(index_ + 9),
                  setSignatureOptions(
                    new Date(
                      JSON.parse(Cookies.get("ossObj")).Expiration
                    ).getTime() / 1000
                  )
                );
              }
              return src_;
            }
            if (src.lastIndexOf("chances") == index_) {
              return src;
            }
            if (src.lastIndexOf("order") == index_) {
              let src_;
              if (label) {
                src_ = client.signatureUrl(
                  src.slice(index_),
                  setSignatureOptions(
                    new Date(
                      JSON.parse(Cookies.get("ossObj")).Expiration
                    ).getTime() / 1000,
                    label
                  )
                );
              } else {
                src_ = client.signatureUrl(
                  src.slice(index_),
                  setSignatureOptions(
                    new Date(
                      JSON.parse(Cookies.get("ossObj")).Expiration
                    ).getTime() / 1000
                  )
                );
              }
              console.log(src_);
              return src_;
            }
          } else {
            console.log('其他')
          }
        }
      }
    }
  };
  
  Vue.mixin(mixin);